import React from "react";
import { Container, Row, Col, Form } from "react-bootstrap";

const categories = [
  "All",
  "Insecticide",
  "Fungicide",
  "Herbicide",
  "Plant Growth Regulator",
  "Fertilizer",
  "NPK Fertilizer",
];

const ProductFilters = ({ search, setSearch, category, setCategory }) => {
  return (
    <section className="product-filter-section">
      <Container>
        <Row className="align-items-center">

          {/* SEARCH INPUT */}
          <Col lg={4} md={12} className="mb-3">
            <Form.Control
              type="text"
              placeholder="Search by product or technical name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="product-search"
            />
          </Col>

          {/* CATEGORY FILTER */}
          <Col lg={8} md={12} className="mb-3">
            <div className="category-filter">
              {categories.map((cat, index) => (
                <button
                  key={index}
                  type="button"
                  className={`filter-btn ${category === cat ? "active" : ""
                    }`}
                  onClick={() => setCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
};

export default ProductFilters;
